<c-modal #staticBackdropModal backdrop="static" size="lg" visible='true' id="staticBackdropModal">
  <c-modal-header>
    <h4 class="modal-title">{{ "Expense Detail" }}</h4>
    <button [cModalToggle]="staticBackdropModal.id" cButtonClose (click)="closeModal()" title="Close"></button>
  </c-modal-header>
  <c-modal-body>
    <c-row>
        <form cForm class="animate" (ngSubmit)="saveExpense()" [formGroup]="expenseDetailForm">
          <c-row>
            <c-col [md]='3'>
                <label cLabel for="date">
                    {{"Date" }}
                </label>
            </c-col>
            <c-col [md]='8'>
                <input cFormControl formControlName="date" name="date" type="date" class="form-control" id="date" />
                <div class="alert alert-danger my-1 p-2 fadeInDown animated"
                  *ngIf="expenseDetailForm.controls['date'].hasError('required') && !expenseDetailForm.controls['date'].untouched">
                    {{ "Date is required." }}
                </div>
            </c-col>
          </c-row>
          <c-row>
              <c-col [md]="3">
                  <label cLabel for="item">{{"Item"}}</label>
              </c-col>
              <c-col [md]="8">
                <input
                  formControlName="item" name="item" type="text" id="item"
                  cFormControl
                  placeholder="Select / Enter Item"
                  [typeaheadOptionsLimit]="20"
                  [typeaheadLatinize]="true"
                  [typeahead]="expenseAvailableItems"
                  typeaheadOptionField="item"
                  [typeaheadMinLength]="0"
                  (typeaheadOnSelect)="onSelectExpenseAvailableItem($event)"
                />
                <!-- <input cFormControl formControlName="item" name="item" type="text" class="form-control" id="item" /> -->
                <div class="alert alert-danger my-1 p-2 fadeInDown animated" *ngIf="!expenseDetailForm.controls['item'].valid && !expenseDetailForm.controls['item'].untouched">
                    {{ "Item is required" }}
                </div>
              </c-col>
          </c-row>
          <c-row>
            <c-col [md]="3">
                <label cLabel for="amount">{{"Amount"}}</label>
            </c-col>
            <c-col [md]="8">
                <input cFormControl formControlName="amount" name="amount" type="number" class="form-control" id="amount" />
                <div class="alert alert-danger my-1 p-2 fadeInDown animated" *ngIf="!expenseDetailForm.controls['amount'].valid && !expenseDetailForm.controls['amount'].untouched">
                    {{ "Amount is required" }}
                </div>
            </c-col>
          </c-row>
          <c-row>
            <c-col [md]='3'>
                <label cLabel for="note">
                    {{"Note" }}
                </label>
            </c-col>
            <c-col [md]='8'>
                <input cFormControl formControlName="note" name="note" type="text" class="form-control" id="note" />
                <div class="alert alert-danger my-1 p-2 fadeInDown animated"
                  *ngIf="expenseDetailForm.controls['note'].hasError('required') && !expenseDetailForm.controls['note'].untouched">
                    {{ "Note is required." }}
                </div>
            </c-col>
          </c-row>
        </form>
    </c-row>
  </c-modal-body>
  <c-modal-footer>
    <button cButton color="secondary" (click)="closeModal()">Close</button>
    <button *ngIf="hasEditPermission || hasAddPermission" cButton type="button" color="primary" (click)="saveExpense()"><c-spinner [hidden]="!isSavingExpense"></c-spinner>Submit</button>
    <!-- <button type="submit" class="btn btn-primary primary">
      <i class="fa fa-circle-o-notch fa-spin" [hidden]="!isSavingOwner"></i>
      <c-spinner [hidden]="!isSavingOwner"></c-spinner>{{ "Submit" }}
  </button> -->
  </c-modal-footer>
</c-modal>
